// extracted by mini-css-extract-plugin
module.exports = {"content":"Claim_content__v1rbC","cta":"Claim_cta__3qVs6","claim":"Claim_claim__20SkP","extraSize":"Claim_extraSize__Auef0"};